/* eslint-disable @typescript-eslint/no-explicit-any */
import { fileToBase64 } from "./fileToBase64";

export const uploadMedia = async (files: any) => {
  const media = await Promise.all(
    files.map(async (f: any) => ({
      name: f.file.name,
      type: f.file.type,
      base64: await fileToBase64(f.file),
    }))
  );
  return media;
};
